export const SET_SELECTED_MERGE_FIELD = 'setSelectedMergeField'
export const SET_SELECTED_MERGE_FIELD_NAME = 'setSelectedMergeFieldName'
export const SET_SELECTED_MERGE_FIELD_OPTIONS = 'setSelectedMergeFieldOptions'
export const SET_SELECTED_MERGE_FIELD_EDITABLE = 'setSelectedMergeFieldEditable'

export const SET_SHOW_MERGE_FIELDS_PREVIEW = 'setShowMergeFieldsPreview'
export const SET_SHOW_MERGE_FIELDS_DEFAULTS = 'setShowMergeFieldsDefaults'
export const SET_SELECTED_MERGE_FIELDS_CONTACT = 'setSelectedMergeFieldsContact'
export const SET_MERGE_FIELDS_CONTACTS = 'setMergeFieldsContacts'

export const SET_MERGE_CONTACT_FIELDS = 'setMergeContactFields'
export const SET_MERGE_CONTACT_VALUES = 'setMergeContactValues'

export const SET_MERGE_FIELDS_OPTIONS = 'setMergeFieldsOptions'
export const SET_MERGE_FIELDS_DEFAULTS = 'setMergeFieldsDefaults'
